export const formatCurrency = (num: number) => {
  if (num >= 100000) {
    return (num / 1000).toFixed(0) + "K";
  } else {
    return num.toLocaleString("en-US", { style: "currency", currency: "USD" });
  }
};

export const formatPercent = (num: number) => Math.abs(num).toFixed(0);
